module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-07-4d166899b4310f284c9c5d34cf0c72a0.svg";